import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './Section.styles.js';

var defaultProps = {
  look: "marketing"
};
var SectionPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var children = props.children,
    noMargin = props.noMargin,
    className = props.className,
    look = props.look,
    separator = props.separator,
    fullWidth = props.fullWidth,
    id = props.id;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(look), true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__full-width"), fullWidth), _cleanupClassObject)),
    role: "region"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(lsgPre, "section-inner")
  }, children), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(lsgPre, "section-separator"), !!separator))
  }));
}, defaultProps);
SectionPresentation.displayName = "SectionPresentation";

export { SectionPresentation, defaultProps };
